import { connectBaseApi, authClient, createRpcQuery, createRpcMutation } from "@racoon/api";
import { persistAuthSession } from "@racoon/lib";

const authGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getMe: createRpcQuery(build, authClient, "me", {
      providesTags: ["Auth"],
    }),
    requestOTP: createRpcMutation(build, authClient, "requestOTP"),
    forgotPasswordViaOtp: createRpcMutation(build, authClient, "forgotPasswordViaOtp"),
    resetPassword: createRpcMutation(build, authClient, "resetPassword"),
    refreshToken: createRpcMutation(build, authClient, "refreshToken"),
    login: createRpcMutation(build, authClient, "login", {
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          persistAuthSession(data);
        } catch {}
      },
    }),
    loginOTP: createRpcMutation(build, authClient, "loginOTP", {
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          persistAuthSession(data);
        } catch {}
      },
    }),
    selfRegisterViaLink: createRpcMutation(build, authClient, "selfRegisterViaLink"),
  }),
  overrideExisting: false,
});

export const {
  useGetMeQuery,
  useRequestOTPMutation,
  useForgotPasswordViaOtpMutation,
  useResetPasswordMutation,
  useLoginMutation,
  useLoginOTPMutation,
  useSelfRegisterViaLinkMutation,
} = authGrpc;
